import type { CategoryItem } from './category';

export const allBrands: CategoryItem[] = [
  {
    name: '#OOTD beauty',
    url: '/brand/ootd-beauty/',
  },
  {
    name: '107',
    url: '/brand/107/',
  },
  {
    name: '1.618',
    url: '/brand/1-618/',
  },
  {
    name: '12GRABS',
    url: '/brand/12grabs/',
  },
  {
    name: '2aN',
    url: '/brand/2an/',
  },
  {
    name: '2NDESIGN',
    url: '/brand/2ndesign/',
  },
  {
    name: '2SOL',
    url: '/brand/2sol/',
  },
  {
    name: '3M Nexcare',
    url: '/brand/3m-nexcare/',
  },
  {
    name: '9wishes',
    url: '/brand/9wishes/',
  },
  {
    name: 'Anua',
    url: '/brand/anua/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/1.png',
    imageAlt: 'Anua',
  },
  {
    name: 'AHC',
    url: '/brand/ahc/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/2.png',
    imageAlt: 'AHC',
  },
  {
    name: 'AESTURA',
    url: '/brand/aestura/',
    imageUrl: '/brand/Aestura.png',
    imageAlt: 'AESTURA',
  },
  {
    name: 'AMPLE:N',
    url: '/brand/amplen/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/09/31.webp',
    imageAlt: 'AMPLE:N',
  },
  {
    name: "A'demang",
    url: '/brand/3w-clinic/',
  },
  {
    name: "A'pieu",
    url: '/brand/apieu/',
  },
  {
    name: 'Abib',
    url: '/brand/abib/',
    imageUrl: '/brand/Abib.png',
    imageAlt: 'Abib',
  },
  {
    name: 'ABOUT ME',
    url: '/brand/about-me/',
  },
  {
    name: 'ABOUT_TONE',
    url: '/brand/about_tone/',
  },
  {
    name: 'Acnes',
    url: '/brand/acnes/',
  },
  {
    name: 'acropass',
    url: '/brand/acropass/',
  },
  {
    name: 'Acwell',
    url: '/brand/acwell/',
  },
  {
    name: 'ADELIO',
    url: '/brand/adelio/',
  },
  {
    name: 'ADORE4',
    url: '/brand/adore4/',
  },
  {
    name: 'aetem',
    url: '/brand/aetem/',
  },
  {
    name: "AGE 20's",
    url: '/brand/age-20s/',
  },
  {
    name: 'AIPPO',
    url: '/brand/aippo/',
  },
  {
    name: 'ALIVE:LAB',
    url: '/brand/alivelab/',
  },
  {
    name: 'ALLIE',
    url: '/brand/allie/',
  },
  {
    name: 'ALLIONE',
    url: '/brand/allione/',
  },
  {
    name: 'allNATURAL',
    url: '/brand/allnatural/',
  },
  {
    name: 'ALLOY',
    url: '/brand/alloy/',
  },
  {
    name: 'allvit',
    url: '/brand/allvit/',
  },
  {
    name: 'Amill',
    url: '/brand/amill/',
  },
  {
    name: 'AMORE PACIFIC',
    url: '/brand/amore-pacific/',
  },
  {
    name: 'ANESSA',
    url: '/brand/anessa/',
  },
  {
    name: 'Angel',
    url: '/brand/angel/',
  },
  {
    name: 'ANSWER NINETEEN',
    url: '/brand/answer-nineteen/',
  },
  {
    name: 'antitox',
    url: '/brand/antitox/',
  },
  {
    name: 'Aperire',
    url: '/brand/aperire/',
  },
  {
    name: 'APLB',
    url: '/brand/aplb/',
  },
  {
    name: 'Aritaum',
    url: '/brand/aritaum/',
  },
  {
    name: 'Ariul',
    url: '/brand/ariul/',
  },
  {
    name: 'AROCELL',
    url: '/brand/arocell/',
  },
  {
    name: 'AROMATICA',
    url: '/brand/aromatica/',
  },
  {
    name: 'ARZTIN',
    url: '/brand/arztin/',
  },
  {
    name: 'asis-tobe',
    url: '/brand/asis-tobe/',
  },
  {
    name: 'asolution',
    url: '/brand/asolution/',
  },
  {
    name: 'ATELIERB',
    url: '/brand/atelierb/',
  },
  {
    name: 'athe',
    url: '/brand/athe/',
  },
  {
    name: 'ATRUE',
    url: '/brand/atrue/',
  },
  {
    name: 'auau',
    url: '/brand/auau/',
  },
  {
    name: 'audrey&young',
    url: '/brand/audreyyoung/',
  },
  {
    name: 'AVCA',
    url: '/brand/avca/',
  },
  {
    name: 'AVEDA',
    url: '/brand/aveda/',
  },
  {
    name: 'Avene',
    url: '/brand/avene/',
  },
  {
    name: 'ATOMY',
    url: '/brand/atomy/',
  },
  {
    name: "A'demang",
    url: '/brand/ademang/',
  },
  {
    name: 'Beauty of Joseon',
    url: '/brand/beauty-of-joseon/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/3.png',
    imageAlt: 'Beauty of Joseon',
  },
  {
    name: 'BANILA CO',
    url: '/brand/banila-co/',
  },
  {
    name: 'Beauty Recipe',
    url: '/brand/beauty-recipe/',
  },
  {
    name: 'B JEWEL',
    url: '/brand/b-jewel/',
  },
  {
    name: 'B.LAB',
    url: '/brand/b-lab/',
  },
  {
    name: 'BABOR',
    url: '/brand/babor/',
  },
  {
    name: 'Barulab',
    url: '/brand/barulab/',
  },
  {
    name: 'be Flat.',
    url: '/brand/be-flat/',
  },
  {
    name: 'Be The Skin',
    url: '/brand/be-the-skin/',
  },
  {
    name: 'BELLAMONSTER',
    url: '/brand/bellamonster/',
  },
  {
    name: 'benetus',
    url: '/brand/benetus/',
  },
  {
    name: 'BENTON',
    url: '/brand/benton/',
    imageUrl: '/brand/Benton.png',
    imageAlt: 'BENTON',
  },
  {
    name: 'BIODANCE',
    url: '/brand/biodance/',
    imageUrl: '/brand/Biodance.png',
    imageAlt: 'BIODANCE',
  },
  {
    name: 'beplain',
    url: '/brand/beplain/',
  },
  {
    name: 'Bielenda',
    url: '/brand/bielenda/',
  },
  {
    name: 'Bifesta',
    url: '/brand/bifesta/',
  },
  {
    name: 'Bio-Oil',
    url: '/brand/bio-oil/',
  },
  {
    name: 'Bioderma',
    url: '/brand/bioderma/',
  },
  {
    name: 'BIOTHERM',
    url: '/brand/biotherm/',
  },
  {
    name: 'BIOTURM',
    url: '/brand/bioturm/',
  },
  {
    name: 'Blanc Nature',
    url: '/brand/blanc-nature/',
  },
  {
    name: 'BLANCOW',
    url: '/brand/blancow/',
  },
  {
    name: 'Blauche',
    url: '/brand/blauche/',
  },
  {
    name: 'BLITHE',
    url: '/brand/blithe/',
  },
  {
    name: 'BLIVU',
    url: '/brand/blivu/',
  },
  {
    name: 'BOBBI BROWN',
    url: '/brand/bobbi-brown/',
  },
  {
    name: 'BOM',
    url: '/brand/bom/',
  },
  {
    name: 'bona medusa',
    url: '/brand/bona-medusa/',
  },
  {
    name: 'Bonabella',
    url: '/brand/bonabella/',
  },
  {
    name: 'Bonajour',
    url: '/brand/bonajour/',
  },
  {
    name: 'borntree',
    url: '/brand/borntree/',
  },
  {
    name: 'BOTANITY',
    url: '/brand/botanity/',
  },
  {
    name: 'BRINGGREEN',
    url: '/brand/bringgreen/',
  },
  {
    name: 'briskin',
    url: '/brand/briskin/',
  },
  {
    name: 'Brown Lab.',
    url: '/brand/brown-lab/',
  },
  {
    name: 'BRTC',
    url: '/brand/brtc/',
  },
  {
    name: 'BUDDATE',
    url: '/brand/buddate/',
  },
  {
    name: 'BUENO',
    url: '/brand/bueno/',
  },
  {
    name: 'BERGAMO',
    url: '/brand/bergamo/',
  },
  {
    name: 'BY ECOM',
    url: '/brand/by-ecom/',
  },
  {
    name: 'B.READY',
    url: '/brand/b-ready/',
  },
  {
    name: 'Bebeluna',
    url: '/brand/bebeluna/',
  },
  {
    name: 'belif',
    url: '/brand/belif/',
    imageUrl: '/brand/Belif.png',
    imageAlt: 'belif',
  },
  {
    name: 'bye od-td',
    url: '/brand/bye-od-td/',
  },
  {
    name: 'BIO HEAL BOH',
    url: '/brand/bio-heal-boh/',
  },
  {
    name: 'BANOBAGI',
    url: '/brand/banobagi/',
  },
  {
    name: 'COSRX',
    url: '/brand/cosrx/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/5.png',
    imageAlt: 'COSRX',
  },
  {
    name: 'Centellian24',
    url: '/brand/centellian24/',
  },
  {
    name: 'C2Y',
    url: '/brand/c2y/',
  },
  {
    name: 'camiane',
    url: '/brand/camiane/',
  },
  {
    name: 'CAREZONE',
    url: '/brand/carezone/',
  },
  {
    name: 'Catrin',
    url: '/brand/catrin/',
  },
  {
    name: 'CATTIER',
    url: '/brand/cattier/',
  },
  {
    name: 'CELDERMA',
    url: '/brand/celderma/',
  },
  {
    name: 'celepiderme',
    url: '/brand/celepiderme/',
  },
  {
    name: 'CELGEN',
    url: '/brand/celgen/',
  },
  {
    name: 'celimax',
    url: '/brand/celimax/',
  },
  {
    name: 'CELL BLOOM',
    url: '/brand/cell-bloom/',
  },
  {
    name: 'Cell Fusion C',
    url: '/brand/cell-fusion-c/',
  },
  {
    name: 'Cellapy',
    url: '/brand/cellapy/',
  },
  {
    name: 'CELLBN',
    url: '/brand/cellbn/',
  },
  {
    name: 'CELLCURE',
    url: '/brand/cellcure/',
  },
  {
    name: 'CELLIVIATE',
    url: '/brand/celliviate/',
  },
  {
    name: 'Celonia',
    url: '/brand/celonia/',
  },
  {
    name: 'CENTURY RECIPES',
    url: '/brand/century-recipes/',
  },
  {
    name: 'CHARMZONE',
    url: '/brand/charmzone/',
  },
  {
    name: 'CHICA Y CHICO',
    url: '/brand/chica-y-chico/',
  },
  {
    name: 'CHICHO',
    url: '/brand/chicho/',
  },
  {
    name: "CHOCHO'LAB",
    url: '/brand/chocholab/',
  },
  {
    name: 'CICAGO',
    url: '/brand/cicago/',
  },
  {
    name: 'Ciracle',
    url: '/brand/ciracle/',
  },
  {
    name: 'CKD',
    url: '/brand/ckd/',
    imageUrl: '/brand/CKD.png',
    imageAlt: 'CKD',
  },
  {
    name: 'Cledbel',
    url: '/brand/cledbel/',
  },
  {
    name: 'Clinique',
    url: '/brand/clinique/',
  },
  {
    name: 'COACOS',
    url: '/brand/coacos/',
  },
  {
    name: 'COLLINS',
    url: '/brand/collins/',
  },
  {
    name: 'comet',
    url: '/brand/comet/',
  },
  {
    name: 'COMMA.NINE',
    url: '/brand/comma-nine/',
  },
  {
    name: 'COS.W',
    url: '/brand/cos-w/',
  },
  {
    name: 'Cosme Chef',
    url: '/brand/cosme-chef/',
  },
  {
    name: 'COSNORI',
    url: '/brand/cosnori/',
  },
  {
    name: 'COSTOK',
    url: '/brand/costok/',
  },
  {
    name: 'CREMORLAB',
    url: '/brand/cremorlab/',
  },
  {
    name: 'CURECODE',
    url: '/brand/curecode/',
  },
  {
    name: 'CURESYS',
    url: '/brand/curesys/',
  },
  {
    name: 'cutem',
    url: '/brand/cutem/',
  },
  {
    name: 'CNP',
    url: '/brand/cnp/',
  },
  {
    name: 'CLIO',
    url: '/brand/clio/',
  },
  {
    name: 'CHINOSHIOYA',
    url: '/brand/chinoshioya/',
  },
  {
    name: 'chaebgonggan',
    url: '/brand/chaebgonggan/',
  },
  {
    name: 'Dr. Jart+',
    url: '/brand/dr-jart/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/6.png',
    imageAlt: 'Dr. Jart+',
  },
  {
    name: 'Dr.G',
    url: '/brand/dr-g/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/7.png',
    imageAlt: 'Dr.G',
  },
  {
    name: "d'Alba",
    url: '/brand/dalba/',
    imageUrl: '/brand/d_Alba.png',
    imageAlt: "d'Alba",
  },
  {
    name: 'DahRuem',
    url: '/brand/dahruem/',
  },
  {
    name: 'Danahan',
    url: '/brand/danahan/',
  },
  {
    name: 'Dancing whale',
    url: '/brand/dancing-whale/',
  },
  {
    name: 'DARPHIN',
    url: '/brand/darphin/',
  },
  {
    name: 'DAYBE',
    url: '/brand/daybe/',
  },
  {
    name: 'daymellow',
    url: '/brand/daymellow/',
  },
  {
    name: 'daypercent',
    url: '/brand/daypercent/',
  },
  {
    name: 'Dear',
    url: '/brand/dear/',
  },
  {
    name: 'DEAR DAHLIA',
    url: '/brand/dear-dahlia/',
  },
  {
    name: 'Dear Klairs',
    url: '/brand/dear-klairs/',
    imageUrl: '/brand/Dear Klairs.png',
    imageAlt: 'Dear Klairs',
  },
  {
    name: 'DEOPROCE',
    url: '/brand/deoproce/',
  },
  {
    name: "Derm' all matrix",
    url: '/brand/derm-all-matrix/',
  },
  {
    name: 'DERMA FACTORY',
    url: '/brand/derma-factory/',
  },
  {
    name: 'DERMAFIRM',
    url: '/brand/dermafirm/',
  },
  {
    name: 'Dermafix',
    url: '/brand/dermafix/',
  },
  {
    name: 'DERMALINE',
    url: '/brand/dermaline/',
  },
  {
    name: 'DERMASHARE',
    url: '/brand/dermashare/',
  },
  {
    name: 'Dermo therapie',
    url: '/brand/dermo-therapie/',
  },
  {
    name: 'Desembre',
    url: '/brand/desembre/',
  },
  {
    name: 'DESERT ESSENCE',
    url: '/brand/desert-essence/',
  },
  {
    name: 'Detclear',
    url: '/brand/detclear/',
  },
  {
    name: 'DewASSOME',
    url: '/brand/dewassome/',
  },
  {
    name: 'DEWY CEL',
    url: '/brand/dewy-cel/',
  },
  {
    name: 'Dewytree',
    url: '/brand/dewytree/',
  },
  {
    name: "Di'ome",
    url: '/brand/diome/',
  },
  {
    name: 'dixionist',
    url: '/brand/dixionist/',
  },
  {
    name: 'Doctors',
    url: '/brand/doctors/',
  },
  {
    name: 'Donggubat',
    url: '/brand/donggubat/',
  },
  {
    name: 'Dr. Ceuracle',
    url: '/brand/dr-ceuracle/',
  },
  {
    name: 'Dr. Ceuracle',
    url: '/brand/dr-505/',
  },
  {
    name: 'Dr.Bio',
    url: '/brand/dr-bio/',
  },
  {
    name: 'Dr.Bio',
    url: '/brand/dr-different/',
  },
  {
    name: 'Dr.Different',
    url: '/brand/dr-eslee/',
  },
  {
    name: 'dr.eslee',
    url: '/brand/dr-moon/',
  },
  {
    name: 'DR.MOON',
    url: '/brand/dr-myskin/',
  },
  {
    name: 'Dr.MYSKIN',
    url: '/brand/dr-ohkims/',
  },
  {
    name: 'Dr. Oracle',
    url: '/brand/dr-oracle/',
    imageUrl: '/brand/Dr Oracle.png',
    imageAlt: 'Dr Oracle',
  },
  {
    name: 'Dr.Oracle',
    url: '/brand/dr-orga/',
  },
  {
    name: 'DR.Orga',
    url: '/brand/dr-pepti/',
  },
  {
    name: 'DR.PEPTI',
    url: '/brand/dr-relief/',
  },
  {
    name: 'DR+BANGGIWON',
    url: '/brand/drbanggiwon/',
  },
  {
    name: 'Dr.AG',
    url: '/brand/dr-ag/',
  },
  {
    name: 'dinsee',
    url: '/brand/dinsee/',
  },
  {
    name: 'dermalogica',
    url: '/brand/dermalogica/',
  },
  {
    name: 'DONGINBI',
    url: '/brand/donginbi/',
  },
  {
    name: 'Deeponde',
    url: '/brand/deeponde/',
  },
  {
    name: 'Dr.Belmeur',
    url: '/brand/dr-belmeur/',
  },
  {
    name: 'DongKook Pharmaceutical',
    url: '/brand/dongkook-pharmaceutical/',
  },
  {
    name: 'Dermatory',
    url: '/brand/dermatory/',
  },
  {
    name: 'ETUDE',
    url: '/brand/etude/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/8.png',
    imageAlt: 'ETUDE',
  },
  {
    name: 'Elujai',
    url: '/brand/elujai/',
  },
  {
    name: 'EANVIE',
    url: '/brand/eanvie/',
  },
  {
    name: 'Easyderm Beauty',
    url: '/brand/easyderm-beauty/',
  },
  {
    name: 'easydew',
    url: '/brand/easydew/',
  },
  {
    name: 'ecoglam',
    url: '/brand/ecoglam/',
  },
  {
    name: "EDDY'PANDA",
    url: '/brand/eddypanda/',
  },
  {
    name: 'efilow',
    url: '/brand/efilow/',
  },
  {
    name: 'ElaBAND',
    url: '/brand/elaband/',
  },
  {
    name: 'ElishaCoy',
    url: '/brand/elishacoy/',
  },
  {
    name: 'EMBRYOLISSE',
    url: '/brand/embryolisse/',
  },
  {
    name: 'enesti',
    url: '/brand/enesti/',
  },
  {
    name: 'ENPRANI',
    url: '/brand/enprani/',
  },
  {
    name: 'EQQUALBERRY',
    url: '/brand/eqqualberry/',
  },
  {
    name: 'espoir',
    url: '/brand/espoir/',
  },
  {
    name: 'essenHERB',
    url: '/brand/essenherb/',
  },
  {
    name: 'Estee Lauder',
    url: '/brand/estee-lauder/',
  },
  {
    name: 'EKE',
    url: '/brand/eke/',
  },
  {
    name: 'ELENSILIA',
    url: '/brand/elensilia/',
  },
  {
    name: 'EUNYUL',
    url: '/brand/eunyul/',
  },
  {
    name: 'exuviance',
    url: '/brand/exuviance/',
  },
  {
    name: 'factory',
    url: '/brand/factory/',
  },
  {
    name: 'Faith in Face',
    url: '/brand/faith-in-face/',
  },
  {
    name: 'Farm Stay',
    url: '/brand/farm-stay/',
  },
  {
    name: 'FATION',
    url: '/brand/fation/',
  },
  {
    name: 'Feld-apotheke',
    url: '/brand/feld-apotheke/',
  },
  {
    name: 'FFLOW',
    url: '/brand/fflow/',
  },
  {
    name: 'FLEEF',
    url: '/brand/fleef/',
  },
  {
    name: 'Flor de man',
    url: '/brand/flor-de-man/',
  },
  {
    name: 'floun',
    url: '/brand/floun/',
  },
  {
    name: 'Flynn',
    url: '/brand/flynn/',
  },
  {
    name: 'FORENCOS',
    url: '/brand/forencos/',
  },
  {
    name: 'Forit',
    url: '/brand/forit/',
  },
  {
    name: 'Fraijour',
    url: '/brand/fraijour/',
  },
  {
    name: 'FRANCOISE',
    url: '/brand/francoise/',
  },
  {
    name: 'freemay',
    url: '/brand/freemay/',
  },
  {
    name: 'Freeup',
    url: '/brand/freeup/',
  },
  {
    name: 'fromtoday eoseongcho',
    url: '/brand/fromtoday-eoseongcho/',
  },
  {
    name: 'FRUDIA',
    url: '/brand/frudia/',
  },
  {
    name: 'FULLY',
    url: '/brand/fully/',
  },
  {
    name: 'freiol',
    url: '/brand/freiol/',
  },
  {
    name: 'goodal',
    url: '/brand/goodal/',
  },
  {
    name: 'Gamarde',
    url: '/brand/gamarde/',
  },
  {
    name: 'Genabelle',
    url: '/brand/genabelle/',
  },
  {
    name: 'GENTLEMASK',
    url: '/brand/gentlemask/',
  },
  {
    name: 'GINGER6',
    url: '/brand/ginger6/',
  },
  {
    name: 'Glowberry',
    url: '/brand/glowberry/',
  },
  {
    name: 'GOONGBE',
    url: '/brand/goongbe/',
  },
  {
    name: 'GRAYMELIN',
    url: '/brand/graymelin/',
  },
  {
    name: 'groundplan',
    url: '/brand/groundplan/',
  },
  {
    name: 'G9SKIN',
    url: '/brand/g9skin/',
  },
  {
    name: 'Haruharu WONDER',
    url: '/brand/haruharu-wonder/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/10.png',
    imageAlt: 'Haruharu WONDER',
  },
  {
    name: 'Holika Holika',
    url: '/brand/holika-holika/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/11.png',
    imageAlt: 'Holika Holika',
  },
  {
    name: 'Hada Labo',
    url: '/brand/hada-labo/',
  },
  {
    name: 'HAMSOA',
    url: '/brand/hamsoa/',
  },
  {
    name: 'Hanskin',
    url: '/brand/hanskin/',
  },
  {
    name: 'HANYUL',
    url: '/brand/hanyul/',
  },
  {
    name: 'Happy Bath',
    url: '/brand/happy-bath/',
  },
  {
    name: 'HATHERINE',
    url: '/brand/hatherine/',
  },
  {
    name: 'HAYEJIN',
    url: '/brand/hayejin/',
  },
  {
    name: 'Heart Percent',
    url: '/brand/heart-percent/',
  },
  {
    name: 'heimish',
    url: '/brand/heimish/',
  },
  {
    name: 'HERA',
    url: '/brand/hera/',
  },
  {
    name: 'herbloom',
    url: '/brand/herbloom/',
  },
  {
    name: 'Heynature',
    url: '/brand/heynature/',
  },
  {
    name: 'Himalaya',
    url: '/brand/himalaya/',
  },
  {
    name: 'Histoire naturelle',
    url: '/brand/histoire-naturelle/',
  },
  {
    name: 'HomeMediCare',
    url: '/brand/homemedicare/',
  },
  {
    name: 'HONEY ZIP',
    url: '/brand/honey-zip/',
  },
  {
    name: 'HUE_CALM',
    url: '/brand/hue_calm/',
  },
  {
    name: 'HYGGEE',
    url: '/brand/hyggee/',
  },
  {
    name: 'Huxley',
    url: '/brand/huxley/',
  },
  {
    name: 'ILLIYOON',
    url: '/brand/illiyoon/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/12.png',
    imageAlt: 'ILLIYOON',
  },
  {
    name: 'INNISFREE',
    url: '/brand/innisfree/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/13.png',
    imageAlt: 'INNISFREE',
  },
  {
    name: 'IOPE',
    url: '/brand/iope/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/14.png',
    imageAlt: 'IOPE',
  },
  {
    name: 'Isntree',
    url: '/brand/isntree/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/15.png',
    imageAlt: 'Isntree',
  },
  {
    name: 'I.st',
    url: '/brand/i-st/',
  },
  {
    name: "I'm from",
    url: '/brand/im-from/',
    imageUrl: '/brand/ImFrom.png',
    imageAlt: "I'm From",
  },
  {
    name: "I'm Sorry For My Skin",
    url: '/brand/im-sorry-for-my-skin/',
  },
  {
    name: 'ifnery',
    url: '/brand/ifnery/',
  },
  {
    name: 'ilso',
    url: '/brand/ilso/',
  },
  {
    name: "IM'UNNY",
    url: '/brand/imunny/',
  },
  {
    name: 'INCELLDERM',
    url: '/brand/incellderm/',
  },
  {
    name: 'INNOLAB',
    url: '/brand/innolab/',
  },
  {
    name: 'Intermisson',
    url: '/brand/intermisson/',
  },
  {
    name: 'Inward',
    url: '/brand/inward/',
  },
  {
    name: 'ISEHAN',
    url: '/brand/isehan/',
  },
  {
    name: 'ISOI',
    url: '/brand/isoi/',
  },
  {
    name: "It's skin",
    url: '/brand/its-skin/',
  },
  {
    name: 'iUNIK',
    url: '/brand/iunik/',
  },
  {
    name: 'J.flee',
    url: '/brand/j-flee/',
  },
  {
    name: "J'SOOP",
    url: '/brand/jsoop/',
  },
  {
    name: 'Jayeonmaeul',
    url: '/brand/jayeonmaeul/',
  },
  {
    name: 'JAYJUN',
    url: '/brand/jayjun/',
  },
  {
    name: 'JKONA',
    url: '/brand/jkona/',
  },
  {
    name: 'JM Solution',
    url: '/brand/jm-solution/',
  },
  {
    name: 'jmella JNC',
    url: '/brand/jmella/',
  },
  {
    name: 'JUICE TO CLEANSE',
    url: '/brand/juice-to-cleanse/',
  },
  {
    name: 'KAHI',
    url: '/brand/kahi/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/16.png',
    imageAlt: 'KAHI',
  },
  {
    name: 'keenoniks',
    url: '/brand/keenoniks/',
  },
  {
    name: 'KIM JEONG MOON Aloe',
    url: '/brand/kim-jeong-moon-aloe/',
  },
  {
    name: 'KIROCOS',
    url: '/brand/kirocos/',
  },
  {
    name: 'Kiss me',
    url: '/brand/kiss-me/',
  },
  {
    name: 'Klairs',
    url: '/brand/klairs/',
  },
  {
    name: 'KLAVUU',
    url: '/brand/klavuu/',
  },
  {
    name: 'Klederma',
    url: '/brand/klederma/',
  },
  {
    name: 'KOCOSTAR',
    url: '/brand/kocostar/',
  },
  {
    name: 'KOELF',
    url: '/brand/koelf/',
  },
  {
    name: 'Koh Gen Do',
    url: '/brand/koh-gen-do/',
  },
  {
    name: 'KUNDAL',
    url: '/brand/kundal/',
  },
  {
    name: 'kineff',
    url: '/brand/kineff/',
  },
  {
    name: 'LANEIGE',
    url: '/brand/laneige/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/17.png',
    imageAlt: 'LANEIGE',
  },
  {
    name: "L'Occitane",
    url: '/brand/loccitane/',
  },
  {
    name: 'la Lumiere',
    url: '/brand/la-lumiere/',
  },
  {
    name: 'La Roche Posay',
    url: '/brand/la-roche-posay/',
  },
  {
    name: 'LABCLE',
    url: '/brand/labcle/',
  },
  {
    name: 'LABELYOUNG',
    url: '/brand/labelyoung/',
  },
  {
    name: 'LABIORA',
    url: '/brand/labiora/',
  },
  {
    name: 'LABIOTTE',
    url: '/brand/labiotte/',
  },
  {
    name: 'LabNo',
    url: '/brand/labno/',
  },
  {
    name: 'LACTOClear',
    url: '/brand/lactoclear/',
  },
  {
    name: 'Lagom',
    url: '/brand/lagom/',
  },
  {
    name: 'LALUCELL',
    url: '/brand/lalucell/',
  },
  {
    name: 'LAPOTHICELL',
    url: '/brand/lapothicell/',
  },
  {
    name: "Lassie'el",
    url: '/brand/lassieel/',
  },
  {
    name: 'laundryou',
    url: '/brand/laundryou/',
  },
  {
    name: 'Lavi',
    url: '/brand/lavi/',
  },
  {
    name: 'LAVITEM',
    url: '/brand/lavitem/',
  },
  {
    name: 'Lazy Society',
    url: '/brand/lazy-society/',
  },
  {
    name: 'LEADERS COSMETICS',
    url: '/brand/leaders-cosmetics/',
  },
  {
    name: 'LEAFY',
    url: '/brand/leafy/',
  },
  {
    name: 'LINA_BEL',
    url: '/brand/lina_bel/',
  },
  {
    name: 'LINDSAY',
    url: '/brand/lindsay/',
  },
  {
    name: 'LOHASYS',
    url: '/brand/lohasys/',
  },
  {
    name: 'LOLOSKINNY',
    url: '/brand/loloskinny/',
  },
  {
    name: 'LUOKI',
    url: '/brand/luoki/',
  },
  {
    name: "LUCAS'PAPAW REMEDIES",
    url: '/brand/lucaspapaw-remedies/',
  },
  {
    name: 'LUSH LANOA',
    url: '/brand/lush/',
  },
  {
    name: 'LALAFOLIE',
    url: '/brand/lalafolie/',
  },
  {
    name: 'MAY COOP',
    url: '/brand/may-coop/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/18.png',
    imageAlt: 'MAY COOP',
  },
  {
    name: 'MEDIHEAL',
    url: '/brand/mediheal/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/19.png',
    imageAlt: 'MEDIHEAL',
  },
  {
    name: 'MISSHA',
    url: '/brand/missha/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/20.png',
    imageAlt: 'MISSHA',
  },
  {
    name: 'M_CURIE',
    url: '/brand/m_curie/',
  },
  {
    name: 'MAC',
    url: '/brand/mac/',
  },
  {
    name: 'Madeca21',
    url: '/brand/madeca21/',
  },
  {
    name: 'MACQUEEN',
    url: '/brand/macqueen/',
  },
  {
    name: 'makeup helper',
    url: '/brand/makeup-helper/',
  },
  {
    name: 'Mamonde',
    url: '/brand/mamonde/',
  },
  {
    name: 'Mary&May',
    url: '/brand/marymay/',
  },
  {
    name: 'MatriCol',
    url: '/brand/matricol/',
  },
  {
    name: 'MAXCLINIC',
    url: '/brand/maxclinic/',
  },
  {
    name: "MECHNIKOV'S",
    url: '/brand/mechnikovs/',
  },
  {
    name: 'MediAnswer',
    url: '/brand/medianswer/',
  },
  {
    name: 'medicube',
    url: '/brand/medicube/',
    imageUrl: '/brand/Medicube.png',
    imageAlt: 'medicube',
  },
  {
    name: 'MediFlower',
    url: '/brand/mediflower/',
  },
  {
    name: 'MEDIPAWPAW',
    url: '/brand/medipawpaw/',
  },
  {
    name: 'melixir',
    url: '/brand/melixir/',
  },
  {
    name: 'menthology',
    url: '/brand/menthology/',
  },
  {
    name: 'MERZY',
    url: '/brand/merzy/',
  },
  {
    name: 'Milk Touch',
    url: '/brand/milk-touch/',
  },
  {
    name: 'MILKYDRESS',
    url: '/brand/milkydress/',
  },
  {
    name: 'mitoON',
    url: '/brand/mitoon/',
  },
  {
    name: 'mixsoon',
    url: '/brand/mixsoon/',
  },
  {
    name: 'MIZON',
    url: '/brand/mizon/',
  },
  {
    name: 'Moremo',
    url: '/brand/moremo/',
  },
  {
    name: 'MOTHER MADE',
    url: '/brand/mother-made/',
  },
  {
    name: 'murir',
    url: '/brand/murir/',
  },
  {
    name: 'MURREN',
    url: '/brand/murren/',
  },
  {
    name: 'My Dahlia',
    url: '/brand/my-dahlia/',
  },
  {
    name: 'MEDIPEEL+',
    url: '/brand/medipeel-3/',
  },
  {
    name: 'make p:rem',
    url: '/brand/make-prem/',
  },
  {
    name: 'ma:nyo',
    url: '/brand/manyo/',
    imageUrl: '/brand/Manyo.png',
    imageAlt: 'ma:nyo',
  },
  {
    name: 'Mont Herb',
    url: '/brand/mont-herb/',
  },
  {
    name: 'MU:STEM',
    url: '/brand/mustem/',
  },
  {
    name: 'MIBA',
    url: '/brand/miba/',
  },
  {
    name: 'MARSHIQUE',
    url: '/brand/marshique/',
  },
  {
    name: 'nooni',
    url: '/brand/nooni/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/11/NOONI-Brand-Logos.png',
    imageAlt: 'nooni',
  },
  {
    name: 'NACIFIC',
    url: '/brand/nacific/',
  },
  {
    name: 'NARD',
    url: '/brand/nard/',
  },
  {
    name: 'NASUDA',
    url: '/brand/nasuda/',
  },
  {
    name: 'Nature Republic',
    url: '/brand/nature-republic/',
  },
  {
    name: 'NEEDLY',
    url: '/brand/needly/',
  },
  {
    name: 'NEOGEN DERMALOGY',
    url: '/brand/neogen-dermalogy/',
  },
  {
    name: 'NESURA',
    url: '/brand/nesura/',
  },
  {
    name: 'NIVEA',
    url: '/brand/nivea/',
  },
  {
    name: 'Nightingale',
    url: '/brand/nightingale/',
  },
  {
    name: 'NOT SEE BACK',
    url: '/brand/not-see-back/',
  },
  {
    name: 'nots',
    url: '/brand/nots/',
  },
  {
    name: 'NOWATER',
    url: '/brand/nowater/',
  },
  {
    name: 'NUCIO',
    url: '/brand/nucio/',
  },
  {
    name: 'numbuzin',
    url: '/brand/numbuzin/',
  },
  {
    name: 'nurisoop',
    url: '/brand/nurisoop/',
  },
  {
    name: 'NUXE',
    url: '/brand/nuxe/',
  },
  {
    name: 'NATINDA',
    url: '/brand/natinda/',
  },
  {
    name: 'Neutrogena',
    url: '/brand/neutrogena/',
  },
  {
    name: 'naturie',
    url: '/brand/naturie/',
  },
  {
    name: 'NATUREKIND',
    url: '/brand/naturekind/',
  },
  {
    name: "O'LYSEE",
    url: '/brand/olysee/',
  },
  {
    name: 'OAIIV',
    url: '/brand/oaiiv/',
  },
  {
    name: 'OHAVE',
    url: '/brand/ohave/',
  },
  {
    name: 'Olivarrier',
    url: '/brand/olivarrier/',
  },
  {
    name: 'ONE THING',
    url: '/brand/one-thing/',
  },
  {
    name: "One-day's you",
    url: '/brand/one-days-you/',
  },
  {
    name: 'ongredients',
    url: '/brand/ongredients/',
  },
  {
    name: 'OPSKIN',
    url: '/brand/opskin/',
  },
  {
    name: 'Pyunkang Yul',
    url: '/brand/pyunkang-yul/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/21.png',
    imageAlt: 'Pyunkang Yul',
  },
  {
    name: 'P.CALM',
    url: '/brand/p-calm/',
  },
  {
    name: 'PAIR Acne',
    url: '/brand/pair-acne/',
  },
  {
    name: 'papa recipe',
    url: '/brand/papa-recipe/',
  },
  {
    name: 'PAUL MEDISON',
    url: '/brand/paul-medison/',
  },
  {
    name: "PAULA'S CHOICE",
    url: '/brand/paulas-choice/',
  },
  {
    name: 'PETITFEE',
    url: '/brand/petitfee/',
  },
  {
    name: 'Pharm Tree',
    url: '/brand/pharm-tree/',
  },
  {
    name: 'PHYSIOGEL',
    url: '/brand/physiogel/',
  },
  {
    name: 'PIBUMI',
    url: '/brand/pibumi/',
  },
  {
    name: 'pinkp!ck',
    url: '/brand/pinkpck/',
  },
  {
    name: 'PLAGENTRA',
    url: '/brand/plagentra/',
  },
  {
    name: 'POCKET PAPER',
    url: '/brand/pocket-paper/',
  },
  {
    name: 'Point&',
    url: '/brand/point/',
  },
  {
    name: 'poiuy',
    url: '/brand/poiuy/',
  },
  {
    name: "POND'S",
    url: '/brand/ponds/',
  },
  {
    name: 'pong dang',
    url: '/brand/pong-dang/',
  },
  {
    name: 'preange',
    url: '/brand/preange/',
  },
  {
    name: 'primera',
    url: '/brand/primera/',
  },
  {
    name: 'Prreti',
    url: '/brand/prreti/',
  },
  {
    name: 'PURE LABEL',
    url: '/brand/pure-label/',
  },
  {
    name: 'Purederm',
    url: '/brand/purederm/',
  },
  {
    name: 'PURELU',
    url: '/brand/purelu/',
  },
  {
    name: 'PURITO Seoul',
    url: '/brand/purito-seoul/',
    imageUrl: '/brand/Purito.png',
    imageAlt: 'Purito',
  },
  {
    name: 'pure:K',
    url: '/brand/purek/',
  },
  {
    name: 'Qandi',
    url: '/brand/qandi/',
  },
  {
    name: 'QUA-T',
    url: '/brand/qua-t/',
  },
  {
    name: "QUINN'S",
    url: '/brand/quinns/',
  },
  {
    name: 'ROUND LAB',
    url: '/brand/round-lab/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/22.png',
    imageAlt: 'ROUND LAB',
  },
  {
    name: 'rom&nd',
    url: '/brand/romnd/',
  },
  {
    name: 'RAWQUEST',
    url: '/brand/rawquest/',
  },
  {
    name: 'Rbfy.',
    url: '/brand/rbfy/',
  },
  {
    name: 'Real Barrier',
    url: '/brand/real-barrier/',
  },
  {
    name: 'reduire',
    url: '/brand/reduire/',
  },
  {
    name: 'reinsaeng',
    url: '/brand/reinsaeng/',
  },
  {
    name: 'REJURAN',
    url: '/brand/rejuran/',
  },
  {
    name: 'Ricocell',
    url: '/brand/ricocell/',
  },
  {
    name: 'RiRe',
    url: '/brand/rire/',
  },
  {
    name: 'RNW',
    url: '/brand/rnw/',
  },
  {
    name: 'Rokkiss',
    url: '/brand/rokkiss/',
  },
  {
    name: 'ROVECTIN',
    url: '/brand/rovectin/',
  },
  {
    name: 'RUBELLI',
    url: '/brand/rubelli/',
  },
  {
    name: 'RE:CIPE',
    url: '/brand/recipe/',
  },
  {
    name: 'Re:NK',
    url: '/brand/renk/',
  },
  {
    name: 'SIDMOOL',
    url: '/brand/sidmool/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/23.png',
    imageAlt: 'SIDMOOL',
  },
  {
    name: 'SKIN1004',
    url: '/brand/skin1004/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/skin1004.png',
    imageAlt: 'SKIN1004',
  },
  {
    name: 'SKINFOOD',
    url: '/brand/skinfood/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/25.png',
    imageAlt: 'SKINFOOD',
  },
  {
    name: 'SOME BY MI',
    url: '/brand/some-by-mi/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/26.png',
    imageAlt: 'SOME BY MI',
  },
  {
    name: 'Sulwhasoo',
    url: '/brand/sulwhasoo/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/27.png',
    imageAlt: 'Sulwhasoo',
  },
  {
    name: 'S.NATURE',
    url: '/brand/s-nature/',
  },
  {
    name: 'Saborino',
    url: '/brand/saborino/',
  },
  {
    name: 'SAMPAR',
    url: '/brand/sampar/',
  },
  {
    name: 'Sandawha',
    url: '/brand/sandawha/',
  },
  {
    name: 'SCENEARTH',
    url: '/brand/scenearth/',
  },
  {
    name: 'Scinic',
    url: '/brand/scinic/',
  },
  {
    name: 'SE-SALO',
    url: '/brand/se-salo/',
  },
  {
    name: 'sebamed',
    url: '/brand/sebamed/',
  },
  {
    name: 'Secretplant',
    url: '/brand/secretplant/',
  },
  {
    name: 'SENITE',
    url: '/brand/senite/',
  },
  {
    name: 'SENKA',
    url: '/brand/senka/',
  },
  {
    name: 'SHARCART',
    url: '/brand/sharcart/',
  },
  {
    name: 'SHEATERRA ORGANICS',
    url: '/brand/sheaterra-organics/',
  },
  {
    name: 'Shiseido',
    url: '/brand/shiseido/',
  },
  {
    name: 'simplog.',
    url: '/brand/simplog/',
  },
  {
    name: 'simplyO',
    url: '/brand/simplyo/',
  },
  {
    name: 'sioris',
    url: '/brand/sioris/',
  },
  {
    name: 'SK-II',
    url: '/brand/sk-ii/',
  },
  {
    name: 'SKIN&LAB',
    url: '/brand/skinlab/',
  },
  {
    name: 'SKIN9HARI',
    url: '/brand/skin9hari/',
  },
  {
    name: 'SKINEYE',
    url: '/brand/skineye/',
  },
  {
    name: 'SKINMISO',
    url: '/brand/skinmiso/',
  },
  {
    name: 'SKINRx LAB',
    url: '/brand/skinrx-lab/',
  },
  {
    name: 'SLOW THERAPY',
    url: '/brand/slow-therapy/',
  },
  {
    name: 'SNP',
    url: '/brand/snp/',
  },
  {
    name: 'so natural',
    url: '/brand/so-natural/',
  },
  {
    name: 'SONBAHYU',
    url: '/brand/sonbahyu/',
  },
  {
    name: 'SRB',
    url: '/brand/srb/',
  },
  {
    name: 'Sroum',
    url: '/brand/sroum/',
  },
  {
    name: 'SUAVISS',
    url: '/brand/suaviss/',
  },
  {
    name: 'suiskin',
    url: '/brand/suiskin/',
  },
  {
    name: 'SUNGBOON EDITOR',
    url: '/brand/sungboon-editor/',
  },
  {
    name: 'SUR.MEDIC',
    url: '/brand/sur-medic/',
  },
  {
    name: 'Surepi',
    url: '/brand/surepi/',
  },
  {
    name: 'Swanicoco',
    url: '/brand/swanicoco/',
  },
  {
    name: 'Siimes',
    url: '/brand/siimes/',
  },
  {
    name: 'Sum:37',
    url: '/brand/sum37/',
  },
  {
    name: 'TONYMOLY',
    url: '/brand/tonymoly/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/28.png',
    imageAlt: 'TONYMOLY',
  },
  {
    name: 'Torriden',
    url: '/brand/torriden/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/29.png',
    imageAlt: 'Torriden',
  },
  {
    name: 'THANK YOU FARMER',
    url: '/brand/thank-you-farmer/',
  },
  {
    name: "T'else",
    url: '/brand/telse/',
  },
  {
    name: 'TABITHA',
    url: '/brand/tabitha/',
  },
  {
    name: 'Tage TALLO',
    url: '/brand/tage/',
  },
  {
    name: 'TAN',
    url: '/brand/tan/',
  },
  {
    name: 'TEABLESS',
    url: '/brand/teabless/',
  },
  {
    name: 'THALGO',
    url: '/brand/thalgo/',
  },
  {
    name: 'The Body Shop',
    url: '/brand/the-body-shop/',
  },
  {
    name: 'The BOIBOY',
    url: '/brand/the-boiboy/',
  },
  {
    name: 'The Face Shop',
    url: '/brand/the-face-shop/',
  },
  {
    name: 'THE iLLON',
    url: '/brand/the-illon/',
  },
  {
    name: 'THE LAB by blanc doux',
    url: '/brand/the-lab-by-blanc-doux/',
  },
  {
    name: 'The Ordinary',
    url: '/brand/the-ordinary/',
  },
  {
    name: 'the SAEM',
    url: '/brand/the-saem/',
  },
  {
    name: 'The YEON',
    url: '/brand/the-yeon/',
  },
  {
    name: 'ThelaviCos',
    url: '/brand/thelavicos/',
  },
  {
    name: 'THEPIU',
    url: '/brand/thepiu/',
  },
  {
    name: 'theraderm',
    url: '/brand/theraderm/',
  },
  {
    name: 'THREE Tiam',
    url: '/brand/three/',
  },
  {
    name: 'TIRTIR',
    url: '/brand/tirtir/',
  },
  {
    name: 'TOCOBO',
    url: '/brand/tocobo/',
  },
  {
    name: 'TOUN28',
    url: '/brand/toun28/',
  },
  {
    name: 'TRANSSE',
    url: '/brand/transse/',
  },
  {
    name: 'TREEANNSEA',
    url: '/brand/treeannsea/',
  },
  {
    name: 'Trilogy',
    url: '/brand/trilogy/',
  },
  {
    name: 'Troxederm',
    url: '/brand/troxederm/',
  },
  {
    name: 'The Medi Dr.+',
    url: '/brand/the-medi-dr-2/',
  },
  {
    name: 'TWINKLA',
    url: '/brand/twinkla/',
  },
  {
    name: 'TRUE DIVE',
    url: '/brand/true-dive/',
  },
  {
    name: 'Tosowoong',
    url: '/brand/tosowoong/',
  },
  {
    name: 'The History of Whoo',
    url: '/brand/the-history-of-whoo/',
  },
  {
    name: 'UIQ UltraV',
    url: '/brand/uiq/',
  },
  {
    name: 'UNEEDA',
    url: '/brand/uneeda/',
  },
  {
    name: 'URANG',
    url: '/brand/urang/',
  },
  {
    name: 'ureun',
    url: '/brand/ureun/',
  },
  {
    name: 'URIAGE',
    url: '/brand/uriage/',
  },
  {
    name: 'US LOHA',
    url: '/brand/us-loha/',
  },
  {
    name: 'unpa',
    url: '/brand/unpa/',
  },
  {
    name: 'V&CO',
    url: '/brand/vco/',
  },
  {
    name: 'Veganifect',
    url: '/brand/veganifect/',
  },
  {
    name: 'VELY VELY',
    url: '/brand/vely-vely/',
  },
  {
    name: 'VERIDIQUE',
    url: '/brand/veridique/',
  },
  {
    name: 'VIBAS',
    url: '/brand/vibas/',
  },
  {
    name: 'VIDIVICI',
    url: '/brand/vidivici/',
  },
  {
    name: 'VITAHALO',
    url: '/brand/vitahalo/',
  },
  {
    name: 'vividraw',
    url: '/brand/vividraw/',
  },
  {
    name: 'VT COSMETICS',
    url: '/brand/vt-cosmetics/',
  },
  {
    name: 'vanini',
    url: '/brand/vanini/',
  },
  {
    name: 'V-CERA',
    url: '/brand/v-cera/',
  },
  {
    name: 'WELLAGE',
    url: '/brand/wellage/',
  },
  {
    name: 'W. SKIN LABORATORY',
    url: '/brand/w-skin-laboratory/',
  },
  {
    name: 'WellDerma',
    url: '/brand/wellderma/',
  },
  {
    name: 'WHAMISA',
    url: '/brand/whamisa/',
  },
  {
    name: 'WINAGE',
    url: '/brand/winage/',
  },
  {
    name: 'WONDER BATH',
    url: '/brand/wonder-bath/',
  },
  {
    name: 'wonryogongbang',
    url: '/brand/wonryogongbang/',
  },
  {
    name: 'wooliliwoo',
    url: '/brand/wooliliwoo/',
  },
  {
    name: 'WHIPPED',
    url: '/brand/whipped/',
  },
  {
    name: 'Yadah',
    url: '/brand/yadah/',
  },
  {
    name: 'YAKSON',
    url: '/brand/yakson/',
  },
  {
    name: 'Yashuv',
    url: '/brand/yashuv/',
  },
  {
    name: 'youlief',
    url: '/brand/youlief/',
  },
  {
    name: 'YURICA',
    url: '/brand/yurica/',
  },
  {
    name: 'yuripibu',
    url: '/brand/yuripibu/',
  },
  {
    name: 'YVESOM',
    url: '/brand/yvesom/',
  },
  {
    name: 'young:see',
    url: '/brand/youngsee/',
  },
  {
    name: 'YE HWA DAM',
    url: '/brand/ye-hwa-dam/',
  },
  {
    name: 'ZYMOGEN',
    url: '/brand/zymogen/',
  },
  {
    name: 'ZEMU',
    url: '/brand/zemu/',
  },
  {
    name: 'ZEROID',
    url: '/brand/zeroid/',
  },
  {
    name: 'ziaja',
    url: '/brand/ziaja/',
  },
  {
    name: 'ZOMBIE BEAUTY',
    url: '/brand/zombie-beauty/',
  },
] as const;
